import { ButtonBaseProps } from '../proxied-components';
import { CollapsibleIconBaseProps } from './model';

/**
 * Hook that helps set common accessibility (a11y) related props for collapsible content.
 */
export const useCollapsibleA11yProps = ({
  collapsed,
  ariaLabelSubject,
}: CollapsibleIconBaseProps): Pick<ButtonBaseProps, 'aria-label' | 'aria-expanded'> => {
  let ariaLabel = collapsed ? 'Expand' : 'Collapse';
  if (ariaLabelSubject) {
    ariaLabel += ` ${ariaLabelSubject}`;
  }

  return {
    'aria-label': ariaLabel,
    'aria-expanded': !collapsed,
  };
};
